import {
  QuestionAnalysis,
  ResponseDetails,
  SurveyEngagementDetailsDto,
} from '@keyops-cep/api-client';

import { AnswerDataWithDemographic } from '../../pages/EngagementDetails/types';

export const getQuestionAnalysis = (
  engagementDetails: SurveyEngagementDetailsDto,
  questionId: string
): QuestionAnalysis | undefined => {
  return engagementDetails.analysis?.questionAnalyses.find(
    (analysis) => analysis.questionId === questionId
  );
};

export const getQuestionAnswers = (
  engagementResponses: ResponseDetails[],
  questionId: string
): AnswerDataWithDemographic[] => {
  return engagementResponses
    .map((response) => {
      const answer = response.answers.find(
        (answer) => answer.questionId === questionId
      );
      return answer
        ? { ...answer, demographics: response.respondentDemographics }
        : undefined;
    })
    .filter((n) => n !== undefined) as AnswerDataWithDemographic[];
};
